<div class="d-flex justify-content-center h-83">
  <div class="d-flex align-items-center">
    <span class="position-relative">
      <img class="imageSize download" src="/icons/{{baseSiteId}}/download.png" />
      <a class="link ml-1" (click)="downloadPDF()">Download({{totalLength}})</a>
      @if (downloadSuccess) {
        <div id="download_success_msg" class="download_value_added">
          <img src="/icons/confirmation-positive-green.png">
          <span>
            Documents saved successfully
          </span>
          <div class="arrow"></div>
        </div>
      }
    </span>
  </div>
  <div class="d-flex align-items-center ml-4">
    <span class="position-relative">
      <img class="imageSize mailIcon" src="/icons/{{baseSiteId}}/mail.svg" />
      <a class="link ml-1" (click)="openEmailDownloadPopover()">Email({{totalLength}})</a>
      @if (mailSentSuccess) {
        <div id="email_success_msg" class="cart_value_added">
          <img src="/icons/confirmation-positive-green.png">
          <span>
            Your email has been sent.
          </span>
          <div class="arrow"></div>
        </div>
      }
      @if (mailPopup) {
        <div class="customTooltipEmail"
          [ngClass]="email.errors ? 'customTooltipEmailErrorTop' : 'customTooltipEmailTop'">
          <div>
            <label class="label">
              To
            </label>
            <input [formControl]="email" type="email" id="mailTo" class="w-100 emailTo"
              placeholder="email@address.com">
            @if (
              email.value.length==0 &&
              (email.touched ||email.dirty)
              ) {
              <span class="text-danger mt-1 mb-2 float-left fs-12">This field is required</span>
            }
            @if (email.errors) {
              <span class="text-danger mt-1 mb-2 float-left fs-12">Invalid email
              address</span>
            }
            <div class="col d-flex mt-3 p-0">
              <button type="button" id="cancelBtn" class="btn btn-default white-button"
              (click)="closeEmailDownloadPopover()">Cancel</button>
              <button type="submit" id="confirmBtn" class="btn btn-primary ml-3 "
                [disabled]="email.value.length==0 || !email.valid"
              (click)="mailSelectedDocs()">Send</button>
            </div>
          </div>
          <div class="arrow"></div>
        </div>
      }
    </span>
  </div>
</div>
